import { render, staticRenderFns } from "./top-radio.vue?vue&type=template&id=dc9d46b4&scoped=true&"
import script from "./top-radio.vue?vue&type=script&lang=js&"
export * from "./top-radio.vue?vue&type=script&lang=js&"
import style0 from "./top-radio.vue?vue&type=style&index=0&id=dc9d46b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9d46b4",
  null
  
)

export default component.exports